import fetch from 'unfetch'
import { getInstance } from '@/plugins/auth0'
import ApolloClient from 'apollo-boost'

export const authenticatedApolloClient = new ApolloClient({
  uri: `${process.env.VUE_APP_API}/api/v2/graphql`,
  // This is specifically here for testing environments.
  // Without explicitly  telling ApolloClient what http
  // client to use in testing envs, Apollo client will
  // throw an error that it's native fetcher is incompatible
  fetch: fetch as any,
  request: async operation => {
    const auth: any = await getInstance()
    const token = await auth.getTokenSilently()
    operation.setContext({
      headers: {
        authorization: `Bearer ${token}`
      }
    })
  }
})
